import React from "react";
import { useTranslation } from "react-i18next";
import { ShieldCheck } from "lucide-react";
import RoleTable from "./RoleTable/RoleTable";

// Banner styled to match Agency Management / View Agency's blue-gradient
// header treatment, replacing the plain DMSHeader bar this page used
// before — kept local to this file so it doesn't affect any other screen.
const RoleManagement = () => {
  const { t } = useTranslation();

  return (
    <div style={{ margin: "8px", fontFamily: "'Poppins', 'Segoe UI', sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700;800&display=swap');`}</style>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: "10px",
          padding: "10px 14px",
          borderRadius: "10px",
          background: "linear-gradient(120deg, #2E6DA4 0%, #3B82C4 100%)",
          boxShadow: "0 2px 6px rgba(46,109,164,0.2)",
        }}
      >
        <div
          style={{
            width: "28px",
            height: "28px",
            borderRadius: "8px",
            background: "rgba(255,255,255,0.16)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexShrink: 0,
          }}
        >
          <ShieldCheck size={14} color="#fff" />
        </div>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: "14px", fontWeight: 800, color: "#fff", letterSpacing: ".2px" }}>
            {t("role_management_header")}
          </div>
          <div style={{ fontSize: "10.5px", color: "rgba(255,255,255,0.75)", marginTop: "1px" }}>
            Manage roles and permission levels
          </div>
        </div>
      </div>
      <div style={{ marginTop: "10px", backgroundColor: "#fff", borderRadius: "10px" }}>
        <RoleTable />
      </div>
    </div>
  );
};

export default RoleManagement;
